<template>
    <div class="pd-page">
        <div class="pd-page-header">注塑加工-MES系统</div>
        <div class="pd-page-body">
            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>企业类型
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>注塑</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户介绍
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>某塑料加工有限公司是一家生产注塑件、汽车零部件、塑料件、发泡件的中日合资企业，位于大连保税区，可以完成热固化成型，拥有喷涂、印刷设备，完善了从小型产品至大型产品的组装、喷涂、印刷的生产制造体系。产品涉及领域广泛，包含汽车零部件、办公设备配件、医疗设备配件、家电制品配件以及工业、民用制品等等。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户痛点
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>库存数据统计不及时，不准确，管理层看到的数据通常为36小时前</li>
                        <li>人工数据统计，账实不符 </li>
                        <li>成本核算不准确</li>
                        <li>设备运营状态、停机原因等无法及时统计，导致稼动率无法准确统计</li>
                        <li>人工排产对人专业度要求较高，对个人能力依赖度高，排产效率低</li>
                        <li>报工数据不及时、不准确，生产日报通过人工汇总，对管理层决策价值大大缩水</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>解决方案
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>通过IOT实现设备自动数采：对产线总量、产成品数量、不良品数据自动采集</li>
                        <li>设备状态自动采集：停机原因，停机时长自动管理，设备稼动率自动计算</li>
                        <li>自动生成生产日报。</li>
                        <li>物料追溯：实现物料可追溯、生成过程可追溯，精益成本核算</li>
                        <li>条码管理：以条码技术为载体，一箱一码实现出入库管理，库存数据实时统计</li>
                        <li>设备联网群控：指令自动下达、状态实时监控、过程防误控制、故障智能诊断</li>
                        <li>精益生产相关KPI指标分析：效率、产量、人员、质量、设备</li>
                        <li>优化工序协同：机种众多的情况下，对不同机种工艺流程进行良好管控，使得工序/产线生产节拍相互匹配</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>效果/价值
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>消除产量误报及装箱数量统计错误问题，数据准确率有原来95%，提升到99%</li>
                        <li>数据统计时效性由来原来72小时，提高到实时</li>
                        <li>实现单个产品生产过程和质量信息追溯</li>
                        <li>实现业务数字化、设备信息化</li>
                        <li>实现生产全过程管理透明化，加强车间生产组织过程的管理</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "casePage4"
}
</script>

<style scoped>

</style>
